import { getAllCountry } from './../+country/country.selectors';
import { addCountrySuccess } from './../+country/country.actions';

import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as StateActions from './state.actions';
import { StateService } from '../../services/state.service';
import { CountryService } from '../../services/country.service';
import { NotificationService } from '@cradua/core';

@Injectable()
export class StateEffects {
  loadState$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StateActions.loadState),
      exhaustMap((_) =>
        this.stateService.getAllState().pipe(
          map((data) => StateActions.loadStateSuccess({ state: data })),
          catchError((error) => of(StateActions.loadStateFailure({ error })))
        )
      )
    )
  );

  addState$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StateActions.addState),
      concatMap(({ newState }) =>
        this.stateService.createState(newState).pipe(
          map((data) => {
            this.notification.success('Saved Successfully');
            return StateActions.addStateSuccess({ newState: data });
          }),
          catchError((error) =>
            of(StateActions.addStateFailure({ error: error.message }))
          )
        )
      )
    )
  );

  updateState$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StateActions.updateState),
      map((action) => action.updateState),
      concatMap((updateState) =>
        this.stateService.updateState(updateState).pipe(
          map((_) => {
            this.notification.success('Updated Successfully');
            return StateActions.updateStateSuccess({
              updateState: updateState,
            });
          }),
          catchError((error) =>
            of(StateActions.updateStateFailure({ error: error.message }))
          )
        )
      )
    )
  );

  removeState$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StateActions.removeState),
      map((action) => action.ids),
      concatMap((ids) =>
        this.stateService.deleteState(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return StateActions.removeStateSuccess({ ids });
          }),
          catchError((error) =>
            of(StateActions.updateStateFailure({ error: error.message }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private stateService: StateService,
    private notification: NotificationService,
    private countryservice: CountryService
  ) {}
}
